import React, { useCallback, useMemo, useState } from "react";
import { ReactSVG } from "react-svg";

// region External libraries
import { SidebarDrawer } from "@npm-telluria-tecnologia/telluria-ui";
// endregion External libraries
// region Assets
import LogotipoMinifiedWhite from "@assets/company/LogotipoMinifiedWhite.svg";
import LogoTopconCustomer from "@assets/company/TopconCustomer.svg";
// endregion Assets
// region Helpers
import utils from "@helpers/utils";
// endregion Helpers
// region Atoms
import { ExternalSvg, SelectClient } from "@atoms/index";
// endregion Atoms
// region Hooks
import { useWindowDimensions } from "@hooks/useWindowDimensions";
// endregion Hooks
// region Molecules
import { NavbarIcons, SidebarDrawerMenus, SidebarDrawerSecondaryMenus } from "@molecules/index";
// endregion Molecules
// region Libraries
import { Menu } from "@libraries/icons";
// endregion Libraries
// region Styles
import useTheme from "@styles/useTheme";
import * as Styled from "./styles";
import packageJson from "../../../package.json";

// endregion Styles

interface NavbarProps {
  showSelectClient?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ showSelectClient = true }) => {

  const { theme } = useTheme();
  const { width } = useWindowDimensions();

  const [searchIsActive, setSearchIsActive] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);

  const externalProductIconPath = `${utils.getBackendBaseUrl(false)}/visual/LogotipoMinifiedWhite.svg`;

  /**
   * Toggle open / close sidebar
   */
  const toggleOpenSidebar = useCallback(() => {
    setOpenSidebar((value) => !value);
  }, []);

  /**
   * Return logo navbar based on screen width
   */
  const logoNavbar = useMemo(() => {

    const versionClass = width > 1280 ? "version version-desktop" : "version version-mobile";

    return (
      <>
        {width > 1280 ? (
          <ReactSVG src={LogoTopconCustomer} alt="Topcon Customer Logo" />
        ) : (
          <ExternalSvg svgName="LogotipoMinifiedColor" />
        )}
        <div className={versionClass}>V.{packageJson.version}</div>
      </>
    );

  }, [width]);

  return (
    <Styled.Container searchIsActive={searchIsActive}>
      <Styled.NavbarTop
        className="navbar-top"
        showSelectClient={showSelectClient}
      >
        <Menu onClick={toggleOpenSidebar} />
        <SidebarDrawer
          primarycolor={theme.colors.primary}
          productIconPath={externalProductIconPath}
          productIconFallbackPath={LogotipoMinifiedWhite}
          productIconClass="product-sidebar-icon"
          open={openSidebar}
          onClose={toggleOpenSidebar}
          bodyChildren={<SidebarDrawerMenus />}
          footerChildren={<SidebarDrawerSecondaryMenus />}
        />
        <Styled.ProductIconContainer searchIsActive={searchIsActive}>
          {logoNavbar}
        </Styled.ProductIconContainer>
        <NavbarIcons
          searchIsActive={searchIsActive}
          setSearchIsActive={setSearchIsActive}
        />
      </Styled.NavbarTop>
      {showSelectClient && width < 1280 && (
        <Styled.NavbarBottom className="navbar-bottom">
          <SelectClient />
        </Styled.NavbarBottom>
      )}
    </Styled.Container>
  );
};

Navbar.defaultProps = {
  showSelectClient: true
};

export default React.memo(Navbar);
